<template>
  <div id="manageTransportDriver" class="Content-Page">
    <div id="namePage" class="wrap-Main">
      <div class="box-S4 flex-between-center">
        <div class="N-Page T-size-36">Manage Transport Driver</div>
        <v-btn class="theme-btn-even" @click.stop="addItem()">
          <span class="I-create"></span>
          <span>Add Driver</span>
        </v-btn>
      </div>
    </div>
    <div id="tableData" class="wrap-Main">
      <div class="box-S4">
        <v-data-table :headers="headers" :items="items">
          <template v-slot:item.tsd_photo_url="{ item }">
            <img class="B-display" :src="item.tsd_photo_url" />
          </template>
          <template v-slot:item.tsd_active="{ item }" class="text-xs-right">
            <v-icon v-if="item.tsd_active == true">mdi-check</v-icon>
            <v-icon v-else>mdi-close</v-icon>
          </template>
          <template v-slot:item.action="{ item }">
            <div class="b-action">
              <div class="b-btn">
                <v-btn fab class="btn-edit" @click="editItem(item)">
                  <span class="I-edit"></span>
                </v-btn>
                <v-btn fab class="primary btn-delete" @click="deleteItem(item)">
                  <span class="I-bin"></span>
                </v-btn>
              </div>
            </div>
          </template>
        </v-data-table>
      </div>
    </div>
    <!-- dialog สำหรับ เพิ่ม แก้ไข -->
    <v-dialog v-model="dialog" max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <!-- set form กรอกข้อมูลที่นี้ -->
              <v-flex xs10>
                <v-text-field v-model="formModel.tsd_name" label="Name"></v-text-field>
              </v-flex>
              <v-flex xs2>
                <v-checkbox v-model="formModel.tsd_active" label="Active"></v-checkbox>
              </v-flex>
              <v-flex xs4>
                <v-text-field v-model="formModel.tsd_telephone" label="Telephone"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-text-field v-model="formModel.tsd_license" label="License"></v-text-field>
              </v-flex>
              <v-flex xs4>
                <span style="font-size:9pt">LicenseExpiryDate</span>
                <v-menu
                  v-model="menu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="date" readonly dense v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="formModel.tsd_license_expire_date" @input="menu = false"></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex xs12 text-xs-center>
                <uploadform @success="uploadDone">
                  <div slot="activator">
                    <v-avatar size="150px" v-ripple class="mb-3">
                      <img :src="formModel.tsd_photo_url" alt="avatar" />
                    </v-avatar>
                  </div>
                </uploadform>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog">Cancel</v-btn>
          <v-btn :loading="loading" @click="saveToServer">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- dialog สำหรับลบ -->
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">Delete Confirmation</span>
        </v-card-title>

        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex>Delete "{{formModel[Object.keys(formModel)[1]]}}" ?</v-flex>
            </v-layout>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="closeDialog">Cancel</v-btn>
          <v-btn :loading="loading" @click="deleteToServer">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    
    <div id="partBack" class="wrap-Main">
      <div class="line"></div>
      <div class="box-S4">
        <v-btn text class="ColorTheme-S white--text theme-btn" @click="Back()">
          <span class="I-back"></span>
          <span>Back</span>
        </v-btn>
      </div>
    </div>

  </div>
</template>


<script>
import feathersClientUOA from "../plugins/feathers-client-uoa";
import upload from "../utils/upload";
import uploadform from "../components/upload/ImageInput.vue";
export default {
  data: () => ({
    date: new Date().toISOString().substr(0, 10),
    menu: false,
    headers: [
      { value: "tsd_photo_url", text: "", sortable: true },
      { value: "tsd_name", text: "Name", sortable: true },
      { value: "tsd_license", text: "License", sortable: true },
      {
        value: "tsd_license_expire_date",
        text: "License Expiry Date",
        sortable: true
      },
      { value: "tsd_telephone", text: "Phone", sortable: true },
      { value: "tsd_active", text: "Active", sortable: true },
      { value: "action", text: "", sortable: false }
    ],
    defaultValue: {
      tsd_name: "",
      tsd_photo_url: "/img/user.png",
      tsd_license: "",
      tsd_license_expire_date: "",
      tsd_telephone: null,
      tsd_active: "0"
    },
    items: [],
    loading: false,
    dialog: false,
    dialogDelete: false,
    formModel: {},
    mode: "" // มีได้ 2 แบบคือ create กับ edit
  }),
  components: {
    uploadform
  },
  computed: {
    formTitle() {
      return this.mode === "create" ? "Add" : "Edit";
    }
  },
  async mounted() {
    //init here
    this.renderUI();
  },
  methods: {
    Back() {
      this.$router.go(-1);
    },
    async renderUI() {
      try {
        const q = {};
        q.retire = 0;
        var res = await feathersClientUOA
          .service("transportdriver")
          .find({ query: q });
        this.items = res.data;
      } catch (error) {
        console.log(error);
        alert("ไม่สามารถขอข้อมูลจาก server ได้");
      }
    },
    async addItem() {
      this.mode = "create";
      this.formModel = Object.assign({}, this.defaultValue);
      this.dialog = true;
    },

    async editItem(item) {
      this.mode = "edit";
      this.formModel = Object.assign({}, item);
      this.dialog = true;
    },
    async deleteItem(item) {
      this.formModel = Object.assign({}, item);
      this.dialogDelete = true;
    },

    closeDialog() {
      this.dialog = false;
      this.dialogDelete = false;
    },
    async saveToServer() {
      // const valid = await this.$validator.validateAll();
      // if (!valid) {
      //   return;
      // }
      let activity = "";
      if (this.formModel.tsd_active == true) {
        activity = "1";
      } else {
        activity = "0";
      }
      this.loading = true;
      if (this.mode === "edit") {
        try {
          let dataEdit = {
            tsd_name: this.formModel.tsd_name,
            tsd_photo_url: this.formModel.tsd_photo_url,
            tsd_license: this.formModel.tsd_license,
            tsd_license_expire_date: this.formModel.tsd_license_expire_date,
            tsd_telephone: this.formModel.tsd_telephone,
            tsd_active: activity,
            mb: "GEM 2",
            md: new Date()
          };
           alert(JSON.stringify(dataEdit));
          await feathersClientUOA
            .service("transportdriver")
            .patch(this.formModel.tsd_id, dataEdit);
          this.renderUI();
        } catch (err) {
          console.log(err);
        } finally {
          this.loading = false;
        }
      } else {
        //Add Data
        try {
          let dataAdd = {
            tsd_name: this.formModel.tsd_name,
            tsd_photo_url: this.formModel.tsd_photo_url,
            tsd_license: this.formModel.tsd_license,
            tsd_license_expire_date: this.formModel.tsd_license_expire_date,
            tsd_telephone: this.formModel.tsd_telephone,
            tsd_active: activity,
            cb: "GEM 2",
            cd: new Date()
          };
          alert(JSON.stringify(dataAdd));
          await feathersClientUOA.service("transportdriver").create(dataAdd);
          this.renderUI();
        } catch (err) {
          console.log(err);
        } finally {
          this.loading = false;
        }
      }
      this.closeDialog();
    },
    async deleteToServer() {
      this.loading = true;
      try {
        let dataDelete = {
          mb: "GEM 2",
          md: new Date(),
          retire: 1
        };
        await feathersClientUOA
          .service("transportdriver")
          .patch(this.formModel.tsd_id, dataDelete);
        this.renderUI();
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
        this.dialogDelete = false;
      }
    },
    uploadDone(uploadInfo) {
      this.formModel.tsd_photo_url = uploadInfo.url;
    }
  }
};
</script>